import {
  AlertTriangle as AlertTriangleIcon,
  Check as CheckIcon,
  Clock as ClockIcon,
  MoreHorizontal as MoreHorizontalIcon,
  Shield as ShieldIcon,
  UserCheck as UserCheckIcon,
  X as XIcon,
} from 'react-feather'
import { colors } from '@material-ui/core'

const ALL_CATEGORY_ID = 'all'

const PENDING_STATUS_ID = 'pending'
const IN_PROGRESS_STATUS_ID = 'ongoing'
const OVERDUE_STATUS_ID = 'overdue'
const AWAITING_APPROVAL_STATUS_ID = 'awaiting_approval'
const REJECTED_STATUS_ID = 'rejected'
const RISK_ASSUMED_STATUS_ID = 'risk_assumed'
const COMPLETED_STATUS_ID = 'completed'

const AUDIT_AGREES_STATUS_ID = 'audit_agrees'
const AUDIT_DISAGREES_STATUS_ID = 'audit_disagrees'
const AUDIT_CONTESTED_STATUS_ID = 'audit_contested'

const BOARD_CATEGORIES_BUTTONS = [
  {
    id: ALL_CATEGORY_ID,
    name: 'Todas',
  },
  {
    id: PENDING_STATUS_ID,
    name: 'Pendentes',
    icon: MoreHorizontalIcon,
  },
  {
    id: IN_PROGRESS_STATUS_ID,
    name: 'Em andamento',
    icon: ClockIcon,
  },
  {
    id: OVERDUE_STATUS_ID,
    name: 'Atrasadas',
    icon: AlertTriangleIcon,
  },
  {
    id: REJECTED_STATUS_ID,
    name: 'Reprovados',
    icon: XIcon,
  },
  {
    id: AWAITING_APPROVAL_STATUS_ID,
    name: 'Aguardando aprovação',
    icon: UserCheckIcon,
  },
  {
    id: COMPLETED_STATUS_ID,
    name: 'Concluídas',
    icon: CheckIcon,
  },
]

// Projeto coberto por um serviço de Revisão: abas e ordem da spec A5.
const REVIEW_BOARD_CATEGORIES_BUTTONS = [
  { id: ALL_CATEGORY_ID, name: 'Todas' },
  { id: PENDING_STATUS_ID, name: 'Pendentes', icon: MoreHorizontalIcon },
  {
    id: AWAITING_APPROVAL_STATUS_ID,
    name: 'Aguardando revisão',
    icon: ClockIcon,
  },
  { id: REJECTED_STATUS_ID, name: 'Reprovadas', icon: AlertTriangleIcon },
  { id: COMPLETED_STATUS_ID, name: 'Aprovadas', icon: CheckIcon },
  // ponytail: ícone neutro até o desenho definitivo da aba Risco assumido
  { id: RISK_ASSUMED_STATUS_ID, name: 'Risco assumido', icon: ShieldIcon },
]

const REVIEW_OPINION_ITEM_SECTIONS = [
  { kind: 'non_conformity', title: 'Não conformidades' },
  { kind: 'improvement', title: 'Oportunidades de melhoria' },
]

const WITHOUT_CODE_LABEL = 'S/C'

const REVIEW_PENDING_STATUS_IDS = [
  PENDING_STATUS_ID,
  IN_PROGRESS_STATUS_ID,
  OVERDUE_STATUS_ID,
]

const CHOOSE_STATUS_BOARD_COLOR = {
  [PENDING_STATUS_ID]: colors.blueGrey[500],
  [IN_PROGRESS_STATUS_ID]: colors.blue[500],
  [OVERDUE_STATUS_ID]: colors.orange[700],
  [REJECTED_STATUS_ID]: colors.red[500],
  [AWAITING_APPROVAL_STATUS_ID]: colors.yellow[700],
  [COMPLETED_STATUS_ID]: colors.green[500],
  [RISK_ASSUMED_STATUS_ID]: colors.grey[500],
}

const CHOOSE_STATUS_BOARD_ICON = {
  [PENDING_STATUS_ID]: MoreHorizontalIcon,
  [IN_PROGRESS_STATUS_ID]: ClockIcon,
  [OVERDUE_STATUS_ID]: AlertTriangleIcon,
  [REJECTED_STATUS_ID]: XIcon,
  [AWAITING_APPROVAL_STATUS_ID]: UserCheckIcon,
  [COMPLETED_STATUS_ID]: CheckIcon,
  [RISK_ASSUMED_STATUS_ID]: ShieldIcon,
}

const PROGRESS_STATUS_LABELS = {
  [PENDING_STATUS_ID]: 'Pendente',
  [IN_PROGRESS_STATUS_ID]: 'Em andamento',
  [COMPLETED_STATUS_ID]: 'Concluída',
}

const ACTIVITY_STATUS_LABELS = {
  [PENDING_STATUS_ID]: 'Pendente',
  [IN_PROGRESS_STATUS_ID]: 'Em andamento',
  [OVERDUE_STATUS_ID]: 'Atrasada',
  [REJECTED_STATUS_ID]: 'Reprovada',
  [AWAITING_APPROVAL_STATUS_ID]: 'Aguardando aprovação',
  [COMPLETED_STATUS_ID]: 'Concluída',
  [AUDIT_AGREES_STATUS_ID]: 'Auditor Concorda',
  [AUDIT_DISAGREES_STATUS_ID]: 'Auditor Discorda',
  [AUDIT_CONTESTED_STATUS_ID]: 'Contestada',
  [RISK_ASSUMED_STATUS_ID]: 'Risco assumido',
}

const REVIEW_CHOOSE_STATUS_BOARD_COLOR = {
  ...CHOOSE_STATUS_BOARD_COLOR,
  [AWAITING_APPROVAL_STATUS_ID]: colors.indigo[500],
  [REJECTED_STATUS_ID]: colors.orange[700],
  [COMPLETED_STATUS_ID]: colors.green[300],
}

const REVIEW_CHOOSE_STATUS_BOARD_ICON = {
  ...CHOOSE_STATUS_BOARD_ICON,
  [AWAITING_APPROVAL_STATUS_ID]: ClockIcon,
  [REJECTED_STATUS_ID]: AlertTriangleIcon,
}

const REVIEW_ACTIVITY_STATUS_LABELS = {
  ...ACTIVITY_STATUS_LABELS,
  [AWAITING_APPROVAL_STATUS_ID]: 'Aguardando revisão',
  [REJECTED_STATUS_ID]: 'Reprovado',
  [COMPLETED_STATUS_ID]: 'Aprovado',
}

const CONTESTATION_BOARD_CATEGORIES_BUTTONS = [
  { id: ALL_CATEGORY_ID, name: 'Todas' },
  {
    id: AUDIT_AGREES_STATUS_ID,
    name: 'Auditor Concorda',
    icon: MoreHorizontalIcon,
  },
  {
    id: AUDIT_DISAGREES_STATUS_ID,
    name: 'Auditor Discorda',
    icon: AlertTriangleIcon,
  },
  { id: AUDIT_CONTESTED_STATUS_ID, name: 'Contestadas', icon: ClockIcon },
  { id: COMPLETED_STATUS_ID, name: 'Concluídas', icon: CheckIcon },
]

const AUDIT_CHOOSE_STATUS_BOARD_COLOR = {
  [AUDIT_AGREES_STATUS_ID]: colors.blueGrey[500],
  [AUDIT_DISAGREES_STATUS_ID]: colors.orange[500],
  [AUDIT_CONTESTED_STATUS_ID]: colors.blue[500],
  [COMPLETED_STATUS_ID]: colors.grey[500],
}

const AUDIT_CHOOSE_STATUS_BOARD_ICON = {
  [AUDIT_AGREES_STATUS_ID]: MoreHorizontalIcon,
  [AUDIT_DISAGREES_STATUS_ID]: AlertTriangleIcon,
  [AUDIT_CONTESTED_STATUS_ID]: ClockIcon,
  [COMPLETED_STATUS_ID]: CheckIcon,
}

const NOT_LINKABLE_STATUSES_IDS = [
  COMPLETED_STATUS_ID,
  AWAITING_APPROVAL_STATUS_ID,
]

// Mensagem da confirmação nativa exibida ao sair da atividade com alterações não salvas. Fica em
// constants porque o <Prompt> do react-router e o listener de beforeunload precisam do mesmo texto.
const LEAVE_WITH_PENDING_CHANGES_MESSAGE =
  'Você tem alterações não salvas nesta atividade, incluindo arquivos ainda não enviados. ' +
  'Se sair agora, essas alterações serão perdidas.'

const governanceProjectActivity = {
  ACTIVITY_STATUS_LABELS,
  ALL_CATEGORY_ID,
  AUDIT_AGREES_STATUS_ID,
  AUDIT_CHOOSE_STATUS_BOARD_COLOR,
  AUDIT_CHOOSE_STATUS_BOARD_ICON,
  AUDIT_CONTESTED_STATUS_ID,
  AUDIT_DISAGREES_STATUS_ID,
  AWAITING_APPROVAL_STATUS_ID,
  BOARD_CATEGORIES_BUTTONS,
  CHOOSE_STATUS_BOARD_COLOR,
  CHOOSE_STATUS_BOARD_ICON,
  COMPLETED_STATUS_ID,
  CONTESTATION_BOARD_CATEGORIES_BUTTONS,
  IN_PROGRESS_STATUS_ID,
  LEAVE_WITH_PENDING_CHANGES_MESSAGE,
  NOT_LINKABLE_STATUSES_IDS,
  OVERDUE_STATUS_ID,
  PENDING_STATUS_ID,
  PROGRESS_STATUS_LABELS,
  REJECTED_STATUS_ID,
  REVIEW_ACTIVITY_STATUS_LABELS,
  REVIEW_BOARD_CATEGORIES_BUTTONS,
  REVIEW_CHOOSE_STATUS_BOARD_COLOR,
  REVIEW_CHOOSE_STATUS_BOARD_ICON,
  REVIEW_OPINION_ITEM_SECTIONS,
  REVIEW_PENDING_STATUS_IDS,
  RISK_ASSUMED_STATUS_ID,
  WITHOUT_CODE_LABEL,
}

export default governanceProjectActivity
